export enum TokenCategory {
  AI = "AI",
  Solana = "SOLANA",
  ETH = "ETH",
  Base = "BASE",
  Memecoin = "MEMECOIN",
}
